import { render, staticRenderFns } from "./SanityQuoteSerializer.vue?vue&type=template&id=39f4bf6c&scoped=true&"
import script from "./SanityQuoteSerializer.vue?vue&type=script&lang=ts&"
export * from "./SanityQuoteSerializer.vue?vue&type=script&lang=ts&"
import style0 from "./SanityQuoteSerializer.vue?vue&type=style&index=0&id=39f4bf6c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4bf6c",
  null
  
)

export default component.exports